<template>
  <div class="d-flex align-center">
    <Avatar
      :user-id="element.userId"
      size="24"
    />
    <div class="elementInfo mx-2">
      {{ elementInfo }}
    </div>
    <v-btn
      text
      small
      color="primary"
      style="text-transform: none"
      @click="scrollToAnalysisElement(element.element.id)"
    >
      {{ $t('extension.summary.goToTopElement') }}
    </v-btn>
  </div>
</template>
<script>
import moment from 'moment';
import Avatar from '../avatar/Avatar';
import { scrollToAnalysisElement } from './analysisHelper';

export default {
  name: 'TopElementUserBar',
  components: {
    Avatar,
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  computed: {
    elementInfo() {
      let prefix;

      switch (this.element.element.type) {
        case 'comment':
          prefix = this.$t('extension.summary.commented');
          break;
        case 'highlight':
          prefix = this.$t('extension.summary.highlightedElement');
          break;
        default:
          prefix = this.$t('extension.summary.addedElement');
      }

      return `${prefix} ${moment(this.element.element.timestamp).fromNow()}`;
    },
  },
  methods: {
    scrollToAnalysisElement,
  },
};
</script>
<style scoped>
.elementInfo {
  font-size: 12px;
  font-weight: 500;
  color: #737373;
}
</style>
